// src/components/TodasView.jsx
import React, { useRef, useState } from "react";
import TaskBoard from "./TaskBoard";
import CreateListModal from "./CreateListModal";
import CreateTaskModal from "./CreateTaskModal";
import TaskDetailModal from "./TaskDetailModal";
import AttachModal from "./AttachModal";
import ColumnsConfigModal from "./ColumnsConfigModal";

const TodasView = ({
  searchInput,
  setSearchInput,
  zoomLevel,
  increaseZoom,
  decreaseZoom,
  isActivePlus,
  isActiveDash,
  lists,
  tasks,
  listColors,
  ownerUid,
  openNewListModal,
  openTaskModal,
  handleDeleteListClick,
  openDetailModal,
  openAttachModal,
  selectedTask,
  isListModalOpen,
  isTaskModalOpen,
  isDetailModalOpen,
  isAttachModalOpen,
  closeNewListModal,
  closeTaskModal,
  closeDetailModal,
  closeAttachModal,
  handleAttachmentsUpdated,
  currentList,
  taskToEdit,
  listToEdit,
  setListToEdit,
  selectedProject,
  customStyles,
  customStyles2,
  usuarios,
  boxStyle,
}) => {
  const gearRef = useRef(null);
  const [showCols, setShowCols] = useState(false);

  // visibilidades por defecto (ajústalas a gusto)
  const [cols, setCols] = useState({
    etiquetas: true,
    usuarios: true,
    comentarios: true,
    archivos: true,
  });

  return (
    <>
      {/* ───────── Toolbar rápido ───────── */}
      <div className="grupo-empty-toolbar">
        <button
          ref={gearRef}
          title="Configuración"
          onClick={() => setShowCols(true)}
          style={{
            // estilo redondo tipo “chip” (inline)
            background: "#EAEDF0",
            color: "#44566C",
            borderRadius: "50%",
            height: 32,
            width: 32,
            border: "none",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 0,
            lineHeight: 0,
            fontSize: 16,
          }}
        >
          <i className="bi bi-gear" />
        </button>

        <div className="buscar-input" style={{ justifySelf: "start" }}>
          <i className="bi bi-search" />
          <input
            type="text"
            placeholder="Buscar Tareas..."
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            size={28}
          />
        </div>

        <button
          className="new-task-button"
          onClick={() => openNewListModal(null)}
        >
          <i className="bi bi-plus-lg" /> Nuevo
        </button>
      </div>

      {/* ───────── Contenedor principal con borde ───────── */}
      <div style={boxStyle}>
        {lists.length === 0 ? (
          <>
            <p
              style={{
                fontSize: 18,
                color: "#888",
                textAlign: "center",
                marginTop: 100,
              }}
            >
              Crea una lista para empezar a organizar tus tareas.
            </p>
            <img
              src="/img/no-data.svg"
              alt="Sin listas"
              style={{
                display: "block",
                margin: "20px auto",
                width: 300,
                opacity: 0.7,
              }}
            />
          </>
        ) : (
          <TaskBoard
            selectedProject={selectedProject}
            projectLists={lists}
            projectTasks={tasks}
            listColors={listColors}
            zoomLevel={zoomLevel}
            openNewListModal={openNewListModal}
            openTaskModal={openTaskModal}
            handleDeleteListClick={handleDeleteListClick}
            openDetailModal={openDetailModal}
            openAttachModal={openAttachModal}
            visibleCols={cols}
          />
        )}
      </div>

      {/* ───────── Modales ───────── */}
      {isListModalOpen && (
        <CreateListModal
          isOpen={isListModalOpen}
          onRequestClose={closeNewListModal}
          listToEdit={listToEdit}
          projectId={selectedProject?.id}
          customStyles2={customStyles2}
          ownerUid={ownerUid}
        />
      )}

      {isTaskModalOpen && (
        <CreateTaskModal
          isOpen={isTaskModalOpen}
          onRequestClose={closeTaskModal}
          taskToEdit={taskToEdit}
          listName={currentList?.name}
          projectId={selectedProject?.id}
          listId={currentList?.id}
          customStyles={customStyles}
          usuarios={usuarios}
        />
      )}

      {isDetailModalOpen && (
        <TaskDetailModal
          isOpen={isDetailModalOpen}
          onRequestClose={closeDetailModal}
          selectedTask={selectedTask}
          customStyles2={customStyles2}
        />
      )}

      {isAttachModalOpen && (
        <AttachModal
          isOpen={isAttachModalOpen}
          onRequestClose={closeAttachModal}
          selectedTask={selectedTask}
          customStyles2={customStyles2}
          onAttachmentsUpdated={handleAttachmentsUpdated}
        />
      )}

      <ColumnsConfigModal
        isOpen={showCols}
        onClose={() => setShowCols(false)}
        anchorRef={gearRef}
        value={cols}
        onChange={setCols}
        title="Mostrar"
      />
    </>
  );
};

export default TodasView;
